/** EvolveRPG — English overrides for the Books & Rules feature. Fast-play, momentum-driven voice. */
export const booksEvoEn = {
  // BackerVerifyPage.tsx
  'books.backerVerify.seoDescription': 'Verifying your EvolveRPG backer sign-in link.',
  'books.backerVerify.browseAthenaeum': 'Browse the Playbook',

  // BookStorePage.tsx
  'books.store.seoDescription':
    'Everything you need to play fast — core rules, quick-start guides, and genre modules. Buy to unlock content and earn coins.',
  'books.store.eyebrow': 'The Playbook',
  'books.store.intro':
    'Grab the rules that get you playing faster. Every purchase unlocks playable modules in your campaigns and rewards you with coins for the in-world economy.',
  'books.store.loading': 'Loading the playbook…',
  'books.store.empty': 'No books match this category yet. More drops are coming soon.',

  // BuyButton.tsx
  'books.buy.signInToClaim': 'Sign in to claim this book.',
  'books.buy.ledgerSealed': 'Checkout is locked for now — it’s coming soon.',
  'books.buy.openingVault': 'Opening checkout…',

  // BookDetailPage.tsx
  'books.detail.backToAthenaeum': 'Back to the Playbook',
  'books.detail.unlockOwned': 'You own this book — its content is unlocked across the encyclopedia.',
  'books.detail.unlockClaim': 'Claim this book to unlock its content across the encyclopedia.',
  'books.detail.noDescription': 'No description has been written for this book yet.',
  'books.detail.previewBlurb': 'Preview a sample of this book before you claim it.',
  'books.detail.unlockedLockedNote':
    'Purchase this book to unlock its rules, moves, and content in your encyclopedia — and claim',

  // CampaignLandingPage.tsx
  'books.campaign.previewsEmpty': 'New content is in the works — check back as goals unlock.',
  'books.campaign.pledgeFooter':
    'Pledges are processed securely at checkout. Backing rewards (coins, modules, and encyclopedia unlocks) are granted to your EvolveRPG account once the campaign service goes live.',

  // CampaignLandingPage.tsx — fallback campaign identity, shown only when no real campaign row exists yet
  'books.campaign.fallbackTitle': 'EvolveRPG Core',
  'books.campaign.fallbackTagline': 'A fast-play tabletop RPG that evolves as fast as your table.',
  'books.campaign.fallbackPitch':
    'The momentum is building. EvolveRPG Core is a fully-realized fast-play system — a growing toolkit of moves, monsters, and genre modules that expands with every backer. Fund the campaign and your support builds the game: each stretch goal auto-populates the shared encyclopedia with new playable content you can drop straight into your next session.',

  // PreviewModal.tsx
  'books.preview.cannotDisplay': 'Your device cannot display the preview inline.',
  'books.preview.preparingBody':
    'A sample of this book is being prepped and will appear here shortly. In the meantime, here’s a taste of what’s inside:',
  'books.preview.excerptFallback': 'There’s more where that came from. Claim the book to keep reading.',

  // RulesPage.tsx
  'books.rules.seoDescription':
    'Browse the System Reference Document — rules, moves, and stat blocks for fast-play sessions. EvolveRPG Core now, with more systems to come.',
  'books.rules.eyebrow': 'The Codex',
  'books.rules.intro':
    'The open game content that powers EvolveRPG. Browse rules-relevant entries and dive into the full encyclopedia for stat blocks and details. EvolveRPG ships with its own fast-play Core ruleset today, with more genre modules on the way.',
  'books.rules.loading': 'Loading the codex…',
}
